<template>
  <v-row dense>
    <v-col cols="12" sm="12">
      <v-card class="card-border">
        <v-card-text>
          <v-row dense>
            <v-col v-if="$ability.can('Adicionar','Arquivos')" cols="12">
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn outlined color="blue darken-2" rounded dark depressed small v-on="on">
                    <v-icon left>mdi-plus-circle</v-icon>
                    Adicionar Arquivos
                  </v-btn>
                </template>

                <v-list dense>
                  <v-list-item v-for="(item, i) in novoItems" :key="i" :to="item.to">
                    <v-list-item-title v-if="!item.divider">
                      <v-icon left>{{ item.icon }}</v-icon>
                      {{ item.text }}
                    </v-list-item-title>

                    <v-divider v-else></v-divider>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>

          <v-form ref="formBusca">
            <v-row dense>
              <v-col cols="12" sm="12" md="3">
                <SelectEmpresa @onChanged="empresas = $event" :multiple="true" />
              </v-col>

              <v-col cols="12" sm="12" md="3">
                <SelectCampanha
                  :independent="true"
                  :multiple="true"
                  @onChanged="campanhas = $event"
                />
              </v-col>

              <v-col cols="12" sm="12" md="3">
                <SelectColaborador
                  :multiple="true"
                  :empresas="empresas"
                  label="Colaboradores"
                  @onChanged="colaboradores = $event"
                />
              </v-col>

              <v-col cols="12" sm="12" md="3">
                <v-checkbox
                  v-model="ativo"
                  color="blue"
                  label="Ativos"
                />
              </v-col>

              <v-col cols="12">
                <v-row justify="center">
                  <v-btn
                    outlined
                    color="blue darken-2"
                    rounded
                    dark
                    depressed
                    small
                    @click="buscar()"
                  >
                    <v-icon left>mdi-magnify</v-icon>Buscar
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12">
      <v-card class="card-border">
        <v-card-text>
          <v-data-table
            :headers="table.headers"
            :items="table.data"
            :search="table.search"
            group-by="colaborador"
          >
            <template v-slot:top>
              <v-row dense>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    v-model="table.search"
                    label="Procurar..."
                    prepend-inner-icon="mdi-magnify"
                  />
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`group.header`]="{ items }">
              <td colspan="5" class="text-start">
                <v-icon color="blue darken-1" small>mdi-arrow-right-drop-circle</v-icon>
                {{ items[0].colaborador }}
              </td>
            </template>

            <template v-slot:[`item.tipo`]="{item}">
              <v-icon>{{ getIcon(item.tipo) }}</v-icon>
            </template>

            <template v-slot:[`item.ativo`]="{ item }">
              <v-btn
                :color="item.ativo ? 'green darken-2' : 'red darken-2'"
                :title="item.ativo ? 'Ativo - Clique para desativar' : 'Inativo - Clique para ativar'"
                icon
                @click="$ability.can('Editar','Arquivos') ? AlterAtivo(item) : ''"
              >
                <v-icon>
                  {{ item.ativo ? 'mdi-check' : 'mdi-close' }}
                </v-icon>
              </v-btn>
            </template>

            <template v-slot:[`item.actions`]="{item}">
              <v-btn
                color="cyan darken-1"
                title="Visualizar"
                icon
                @click="openLink(item.url, item.campanha, item.tipo)"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>

    <DialogViewArquivo ref="dialogViewImage" />
  </v-row>
</template>

<script>
import { Arquivos } from "@/services/materiais"

export default {
  name: 'ListArquivos',

  components: {
    SelectEmpresa: () => import("@/components/select/SelectEmpresa"),
    SelectColaborador: () => import("@/components/select/SelectColaborador"),
    SelectCampanha: () => import("../../../components/select/SelectCampanha"),
    DialogViewArquivo: () => import('./components/DialogViewArquivo')
  },

  data() {
    return {
      empresas: [],
      colaboradores: [],
      campanhas: [],
      ativo: true,

      novoItems: [
        // {
        //   icon: 'mdi-image',
        //   text: 'Imagem - Layout',
        //   to: '/materiais/arquivos/image/layout'
        // },
        // {
        //   icon: 'mdi-image',
        //   text: 'Imagem - Avulsa',
        //   to: '/materiais/arquivos/image/upload'
        // },
        // {
        //   divider: true
        // },
        // {
        //   icon: 'mdi-file-pdf',
        //   text: 'PDF - Layout',
        //   to: '/materiais/arquivos/pdf/layout'
        // },
        // {
        //   icon: 'mdi-file-pdf',
        //   text: 'PDF - Avulso',
        //   to: '/materiais/arquivos/pdf/upload'
        // },
        // {
        //   divider: true
        // },
        {
          icon: 'mdi-video',
          text: 'Video - Avulso',
          to: '/materiais/arquivos/video/upload'
        }
      ],

      table: {
        search: "",

        headers: [
          {
            text: "Colaborador",
            value: "colaborador"
          },
          {
            text: "Nome",
            value: "nome"
          },
          {
            text: "Campanha",
            value: "campanha"
          },
          {
            text: "Tipo",
            value: "tipo"
          },
          {
            text: 'Ativo',
            value: 'ativo'
          },
          {
            text: "Actions",
            value: "actions"
          }
        ],

        data: []
      },
    }
  },

  methods: {
    async buscar() {
      if (!this.$refs.formBusca.validate()) return;

      this.$loading.setLoading(true)

      try{
        let arquivos = await new Arquivos().listArquivos(
          this.empresas, this.colaboradores, this.campanhas, this.ativo
        )
        this.table.data = arquivos
      }catch(error){
        console.error(error)
        this.$toast.error(error)
      }finally{
        this.$loading.setLoading(false)
      }
    },

    getIcon(tipo) {
      if (tipo == "image") return "mdi-image";
      if (tipo == "video") return "mdi-video";
      if (tipo == "pdf") return "mdi-file-pdf";
    },

    openLink(link, title, tipo) {
      //window.open(link, "_blank");
      this.$refs.dialogViewImage.show(true, title, tipo, link)
    },

    async AlterAtivo(item) {
      let confirm = await this.$swal.confirm(`Deseja ${item.ativo ? 'desativar' : 'ativar'} este arquivo ?`)
      if(confirm) {
        this.$loading.setLoading(true)
        try{
          console.log('ITEM: ', item)
          await new Arquivos().updateAtivo(item.id, item.cnpj, !item.ativo)
          item.ativo = !item.ativo
        }catch(error){
          console.error(error)
          this.$toast.error(error)
        }finally{
          this.$loading.setLoading(false)
        }
      }
    }
  }
}
</script>
